export const PRICING_ID_T1 = "price_1ThNNjLZ6vKp7sfgj9WzVYcO";
export const PRICING_ID_T1_EXP = "";
export const PRICING_ID_T2 = "";
export const PRICING_ID_T2_EXP = "";
export const DISCOUNT_ID = "B8wLjgZu";
export const PRICING_NAME_T1 = "basic";
export const PRICING_NAME_T2 = "premium";

// Sender.net group IDs
export const SENDER_FREE_GUIDE_GROUP_ID = "bqoRlp";
export const SENDER_PURCHASERS_GROUP_ID = "bkj9Nv";

// App identity (used by blog metadata / JSON-LD)
export const APP_NAME = "ExtensionFast";
export const APP_URL = "https://www.extensionfast.com";
